import { render, staticRenderFns } from "./triage.vue?vue&type=template&id=33667b3e&scoped=true"
import script from "./triage.vue?vue&type=script&lang=js"
export * from "./triage.vue?vue&type=script&lang=js"
import style0 from "./triage.vue?vue&type=style&index=0&id=33667b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33667b3e",
  null
  
)

export default component.exports